import React, { Component } from "react";

//generic components
import HtmlTextBlock from "../../../../../generic_components/components/text_display/HtmlTextBlock";
import CheckBoxList from "../../../../../generic_components/components/check_boxes/CheckBoxList";
import LoadingPgTemplate from "../../../../../generic_components/view/LoadingPgTemplate";
import CariAppFormNavBtnBar from "../../../components/cari_app_form_components/CariAppFormNavBtnBar";
import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";
import CustomCheckBox from "../../../../../generic_components/components/check_boxes/CustomCheckBox";

//generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions";

import { 
    cari_app_form_pg_1_url, 
    cari_app_form_pg_2_url, 
    cari_app_form_pg_3_url, 
    cari_app_form_pg_4_url 
} from "../../../../../router/static_routes";

/*
    props:
        onChangeSetParentState => function to set parent state
        postData => postData json, all post data for this page
        staticUiData => staticUiData json, all static loaded ui data for dropdowns, radio btns, etc
        submitted => true/false, sets the entire page to be disabled,
        pageLoaded => true/false if page is loaded, then render page
*/

class CariAppFormViewPg4 extends Component {
    constructor(Props) {
        super(Props);

        //helper functions
        this.getCariFormPgNum = this.getCariFormPageNum.bind(this);
    }

    getCariFormPageNum() {
        var currentUrl = window.location.pathname;
        var current_cari_pg = null;
        //check which url it corresponds to
        if (currentUrl === cari_app_form_pg_1_url) {
            current_cari_pg = 1;
        }
        else if (currentUrl === cari_app_form_pg_2_url) {
            current_cari_pg = 2;
        }
        else if (currentUrl === cari_app_form_pg_3_url) {
            current_cari_pg = 3;
        }
        else if (currentUrl === cari_app_form_pg_4_url) {
            current_cari_pg = 4;
        }
        else {
            return undefined;
        }
        return current_cari_pg;
    }

    render() {
        const otherTextBoxData = {
            otherOptionTextRequired: true,
            otherOptionTextBoxName: "other_name",
            otherOptionTextBoxMaxLength: 255, 
            otherOptionTextBoxPlaceholder: "Other",
            otherOptionTextBoxClassName: "checkbox_list_other_text_box_format"
        }
        return (
            <div className="scene_element scene_element--fadeinright">
                {(!this.props.pageLoaded) ?
                    <LoadingPgTemplate />
                : null}
                <div className={(this.props.pageLoaded) ? "" : "display_none"}>
                    <br /><br /><br /><br/>
                    
                    <div className="p-grid">
                        <div className="p-col-12 full-height">

                            <label className="cari_section_title_format">How did you hear about this position?</label>

                            
                            <div className="">
                                <div className="p-grid cari_form_row_padding">
                                    <div className="p-col-12">
                                        <br/><br/>

                                        <CheckBoxList
                                            checkBoxOptions={this.props.postData.positionSourceList}
                                            name={"positionSourceList"}
                                            valueList={this.props.postData.positionSourceValueList}
                                            onChangeSetParentState={this.props.onChangeSetParentState}

                                            otherTextBoxData={otherTextBoxData}
                                            disabled={this.props.submitted}
                                        />

                                        {/* <CheckBoxList
                                            checkBoxOptions={this.props.postData.positionSourceList}
                                            name={"positionSourceValueList"}
                                            valueList={this.props.postData.positionSourceValueList}
                                            onChangeSetParentState={this.props.onChangeSetParentState}

                                            otherOptionCheckboxValue={"other"}
                                            otherOptionCheckboxLabel={"Other"}

                                            otherOptionTextBoxPlaceholder={"Other"}
                                            otherOptionTextBoxValue={this.props.postData.other_name}
                                            otherOptionTextBoxName={"other_name"}
                                            otherOptionTextBoxClassName={"checkbox_list_other_text_box_format"}
                                            otherOptionTextBoxMaxLength={255}

                                            disabled={this.props.submitted}
                                            textBoxRequired={true}
                                        /> */}
                                    </div>
                                </div>
                            </div>

                            <br/>

                            <label className="cari_section_title_format"> Submission </label>
                            <div className="">
                                <br/>
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <HtmlTextBlock 
                                            text={this.props.staticUiData.submission_instructions}
                                            className={"cari_small_text"}
                                        />
                                        <div className="p-grid">
                                            <div className="p-col-1 consent_checkbox_margin">
                                                <strong className="sfu_red">*&nbsp;&nbsp;</strong>
                                                <CustomCheckBox
                                                    name={"direct_contact_referees_checkbox_val"}
                                                    onChangeSetParentState={this.props.onChangeSetParentState}
                                                    checked={this.props.postData.direct_contact_referees_checkbox_val}
                                                    disabled={this.props.submitted}
                                                />
                                            </div>
                                            <div className="p-col-11">
                                                <HtmlTextBlock
                                                    text={this.props.staticUiData.direct_contact_referees_checkbox_text}
                                                    className={"cari_small_text"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br/><br/>
                        </div>
                    </div>

                    <div className="p-grid nav_btn_bar_padding">
                        <div className="p-col-12 scene_element scene_element--fadeinright">
                            <CariAppFormNavBtnBar 
                                page_num={this.getCariFormPageNum()} 
                                match={this.props.match}
                                postData={this.props.postData}
                            />
                        </div>
                    </div>   
                </div>

                <CariMainPgFooterView />
            </div>
        );
    }
}
export default CariAppFormViewPg4;